var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.statusClass},[_vm._v(_vm._s((_vm.comitente.active || _vm.comitente.value) ? 'Ativo' : 'Inativo'))])
}
var staticRenderFns = []

export { render, staticRenderFns }